import React, { useEffect, useState } from 'react';

// styles
import './MainTrinityHeader.scss';

// components
import MegaMenu from './MegaMenu';
import CartLogin from './right-section/CartLogin';
import MobileMenu from './mobile-menu/MobileMenu';

// api
import { getUserIsLoggedin } from '../../../../js/api/auth/_login';
import { getCartItem } from '../../../../js/api/shopping-cart/_shopping-cart';
import { fetchHeaderMenu } from '../../../../js/api/_navigation';

// store
import {
    addIsBackendUser,
    addLoggedinUser,
    addUserToken,
} from '../../../../redux/user/user.action';
import {
    addCartItem,
    cartCountUpdate,
    UpdateImpersonateMember,
} from '../../../../redux/shopping-cart/shopping-cart.action';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

// hooks
import { useCookies } from 'react-cookie';
import { sortMenuChronologically, sortNestedMenu } from './constant';
import { NewMenuData } from './wp-header';

const MainTrinityHeader = () => {
    const [menuData, setMenuData] = useState({});
    //const [menuData, setMenuData] = useState(NewMenuData);
    const [headerData, setHeaderData] = useState({});
    const [mainNavigation, setMainNavigation] = useState({});
    const [megaMenu, setMegaMenu] = useState([]);
    const [megaMenuItems, setMegaMenuItems] = useState();
    const [cta, setCta] = useState();
    const [loginButtonData, setLoginButtonData] = useState();
    const [footerData, setFooterData] = useState({});
    const dispatch = useDispatch();
    const user = useSelector(({ user }) => user?.tokens?.access_token);
    const profileuser = useSelector(({ user }) => user.loggedin_user);
    const improfileuser = useSelector(({ cart }) =>
        cart.impersonateMember ? cart.impersonateMember.userprofile : null
    );
    const cartitemupdate = useSelector(
        ({ cart }) => cart.cart_update,
        shallowEqual
    );

    const cartitemimpersonate = useSelector(({ cart }) => cart.impersonateMember);

    const [cookies, setCookie] = useCookies(['name']);
    const [cartCount, setcartCount] = useState(0);

    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [arrowLeft, setArrowLeft] = useState(0);

    // New states for mobile menu
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    const handleMenuEnter = (e, idx) => {
        const itemRect = e.currentTarget.getBoundingClientRect();
        const menuContainerRect = e.currentTarget
            .closest('.main-menu')
            .getBoundingClientRect();

        setArrowLeft(itemRect.left - menuContainerRect.left + itemRect.width / 2);
        setOpenMenuIndex(idx);
    };

    const handleMenuLeave = () => {
        setOpenMenuIndex(null);
    };

    console.log('megaMenu', megaMenu);
    console.log('megaMenuItems', megaMenuItems);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 992);
            // if (window.innerWidth >= 992) setMobileMenuOpen(false); // auto close mobile menu on desktop
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const loadMenu = async () => {
            const data = await fetchHeaderMenu();
            setMenuData(data);
        };

        loadMenu();
    }, []);

    useEffect(() => {
        if (menuData?.header) {
            console.log('menuData.header', menuData.header);
            console.log(
                'menuData.header.main_navigatio',
                menuData.header.main_navigatio
            );
            console.log(
                'menuData.header.main_navigation?.mega_menu',
                menuData.header.main_navigation?.mega_menu
            );
            setFooterData(menuData.header.topbar.left);
            setHeaderData(menuData.header);
            setMainNavigation(menuData.header.main_navigation || {});
            setCta(menuData.header.main_navigation.cta_button || {});
            setLoginButtonData(menuData.header.main_navigation.signin_cta || {});
            setMegaMenu(menuData.header.main_navigation?.mega_menu || []);
            const sortMenuChronologicallyData = menuData.header.main_navigation
                ?.mega_menu?.menu_items
                ? sortNestedMenu(menuData.header.main_navigation?.mega_menu?.menu_items)
                : [];
            setMegaMenuItems(sortMenuChronologicallyData);
        }
        console.log('menuData', menuData);
    }, [menuData]);

    useEffect(() => {
        console.log('openMenuIndex', openMenuIndex);
        console.log('arrowLeft', arrowLeft);
    }, [openMenuIndex]);

    const getCartItems = async () => {
        let memberId = '';
        if (cartitemimpersonate) {
            memberId = cartitemimpersonate.memberId;
        }
        return await getCartItem(memberId);
    };

    const getCartItemsCount = async () => {
        let cartcount = 0;

        const getcartitemResponse = await getCartItems();

        if (getcartitemResponse) {
            const ordercart = getcartitemResponse.Cart;
            if (ordercart && !ordercart.OrderLines) {
                dispatch(addCartItem(ordercart));
                setcartCount(cartcount);
                return cartcount;
            }
            if (ordercart) {
                dispatch(addCartItem(ordercart));
                let tomorrow = new Date();
                let today = new Date();
                tomorrow.setDate(today.getDate() + 30);

                setCookie('basketid', ordercart.BasketID, {
                    path: '/',
                    expires: tomorrow,
                });
            } else {
                dispatch(addCartItem(ordercart));
            }

            if (ordercart) {
                if (ordercart.ItemsCount > 0) {
                    ordercart.OrderLines.forEach((a) => (cartcount += a.Quantity));
                }
            }
        }
        setcartCount(cartcount);
        return cartcount;
    };

    useEffect(() => {
        getUserIsLoggedin().then((response) => {
            if (response) {
                checkUserLoggedIn();
            } else {
                const tokens = {
                    access_token: null,
                    refresh_token: null,
                };
                dispatch(addUserToken(tokens));
                dispatch(addLoggedinUser(null));
                dispatch(cartCountUpdate(null));
                dispatch(addIsBackendUser(false));
                const impersonate = {
                    name: 'None',
                    memberId: null,
                    userprofile: null,
                };
                dispatch(UpdateImpersonateMember(impersonate));
            }
        });

        async function checkUserLoggedIn() {
            if (user) {
                getCartItemsCount();
                let memberId;
                if (cartitemimpersonate) {
                    memberId = cartitemimpersonate.memberId;
                }
            }
        }

        checkUserLoggedIn();
    }, [user]);

    useEffect(() => {
        async function checkUserLoggedIn() {
            const userIsLoggedIn = await getUserIsLoggedin(null);
            if (user && userIsLoggedIn) {
                getCartItemsCount();
                let memberId;
                if (cartitemimpersonate) {
                    memberId = cartitemimpersonate.memberId;
                }
            }
        }

        checkUserLoggedIn();
    }, [cartitemupdate]);

    useEffect(() => {
        console.log('cartCount', cartCount);
    }, [cartCount]);
    console.log('contactUsCta menuData', menuData);

    return (
        <div className="main-container mobile-container-style">
            <div className="left-section">
                <div className="logo">
                    <a
                        href="https://trinityconsultants.com/"
                        className="custom-logo-link"
                        rel="home"
                        aria-current="page">
                        {(megaMenu?.logo || mainNavigation?.logo?.src) && (
                            <img
                                width={122}
                                height={32}
                                src={megaMenu?.logo || mainNavigation?.logo?.src}
                                className="custom-logo"
                                alt="Trinity Consultants logo"
                                decoding="async"
                            />
                        )}
                    </a>
                </div>

                <div className="main-menu">
                    {isMobile ? (
                        <>
                            <MobileMenu
                                menuData={megaMenu}
                                contactUsCta={cta}
                                siginInCta={loginButtonData}
                                footerData={footerData}
                            />
                        </>
                    ) : (
                        Array.isArray(megaMenuItems) &&
                        megaMenuItems.map((val, idx) => (
                            <MegaMenu
                                key={idx}
                                menuData={val}
                                idx={idx}
                                isOpen={openMenuIndex === idx}
                                handleMenuEnter={handleMenuEnter}
                                handleMenuLeave={handleMenuLeave}
                                arrowLeft={arrowLeft}
                            />
                        ))
                    )}
                </div>
            </div>
            <CartLogin
                count={cartCount}
                user={user}
                improfileuser={improfileuser}
                profileuser={profileuser}
            />
        </div>
    );
};

export default MainTrinityHeader;
